import { Subject } from 'rxjs'
import apiResponse from '../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'


class DetailBloc {

    folderListChannel = new Subject();
    uploadDocumentChannel = new Subject();
    generateFolderChannel = new Subject();

    repository = new DetailRepository()

    constructor() {
        this.folderListChannel.next({status: apiResponse.INITIAL})
        this.uploadDocumentChannel.next({status: apiResponse.INITIAL})
        this.generateFolderChannel.next({status: apiResponse.INITIAL})
    }

    fetchFolderList = async (query) => {
        try {
            this.folderListChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchFolderList(query).then((result) => {
                this.folderListChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.folderListChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchUploadDocument = async (query) => {
        try {
            this.uploadDocumentChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUploadDocument(query).then((result) => {
                this.uploadDocumentChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.uploadDocumentChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchGenerateFolder = async (query) => {
        this.generateFolderChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerateFolder(query).then((result) => {
            this.generateFolderChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.generateFolderChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default DetailBloc